/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */

export enum ConfidenceScoreEnum {
	Facility = 1,
	FirstName = 2,
	LastName = FirstName,
	DOB = Facility,
	SSN = 5,
	PartialSSN = Facility,
	Gender = DOB,
	PhoneNumber = 3,
	Address1 = PhoneNumber,
	Address2 = PhoneNumber,
	City = PhoneNumber,
	State = PhoneNumber,
	Zip = PhoneNumber,
}
